import get from 'lodash.get';

export const getJobs = ({ activeJobs }) => (get(activeJobs, 'jobs', []));
export const getSelectedJob = ({ activeJobs }) => (get(activeJobs, 'selectedJob', {}));
export const getSelectedSearchConfig = ({ activeJobs }) => (get(activeJobs, 'selectedJob.selectedSearchConfig', null));
